var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thirdLogin"},[_c('a-spin',{attrs:{"spinning":_vm.spinning,"tip":"加载中","delay":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }